<template>
  <div id="container">
    <div class="item-box-content box-content-title">
      <div class="title-font-style">
        <span>普通退票汇总表</span>
      </div>
    </div>
    <div>
      <el-form
        class="search-style"
        style="padding-bottom:5px;"
        :model="queryParams"
        label-position="left"
      >
        <el-row :gutter="20">
          <el-col :span="6" style="margin-bottom:15px;">
            <el-form-item label="日期：" label-width="45px">
              <el-date-picker
                v-model="time"
                style="width:100%;"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :default-time="['00:00:00','23:59:59']"
                :clearable="false"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="退票编号：" label-width="70px">
              <el-input v-model="valList[0].value"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-bottom:15px;">
            <el-form-item label="公司名称：" label-width="70px">
              <el-input v-model="valList[1].value"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-bottom:15px;">
            <el-form-item label="发票编号：" label-width="85px">
              <el-input v-model="valList[2].value"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="发票类型：" label-width="70px">
              <el-select v-model="valList[3].value" placeholder="请选择">
                <el-option
                  v-for="(item,index) in invoiceType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="退票类型：" label-width="70px">
              <el-select v-model="valList[4].value" placeholder="请选择">
                <el-option
                  v-for="(item,index) in ticketType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-bottom:15px;">
            <el-form-item label="申请人：" label-width="60px">
              <el-input v-model="valList[5].value"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-show="showAll" style="margin-bottom:15px;">
            <el-form-item label="申请时间：" label-width="70px">
              <el-date-picker
                v-model="valList[6].value"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
                style="width:100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-show="showAll">
            <el-form-item label="处理人" label-width="60px">
              <el-input v-model="valList[7].value"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="!showAll ? 6 :18" style="text-align:right;">
            <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button @click="onReset">重置</el-button>
            <el-button @click="exportOut">导出</el-button>
            <el-button type="text" style="margin-left:10px" @click="closeSearch">
              {{word}}
              <i :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"></i>
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="box-table" :style="{height:tableHeight+'px'}">
        <el-table
          :summary-method="getSummaries"
          show-summary
          :max-height="tableHeight"
          border
          ref="tableRef"
          tooltip-effect="dark"
          :data="list"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column label="日期" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{ scope.row.processDate | dateFilterD}}</div>
            </template>
          </el-table-column>
          <el-table-column label="退票编号" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{ scope.row.subNumber || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="公司名称" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{ scope.row.suName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="发票编号" width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{ scope.row.invoiceNumber || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="发票金额" width="110" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.amount |priceFilterNum}}</div>
            </template>
          </el-table-column>
          <el-table-column label="税额" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.taxAmount |priceFilterNum}}</div>
            </template>
          </el-table-column>
          <el-table-column label="发票类型" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.invoiceType || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="退票类型">
            <template slot-scope="scope">
              <div>{{scope.row.type || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="申请人">
            <template slot-scope="scope">
              <div>{{scope.row.createUser|| '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="申请时间">
            <template slot-scope="scope">
              <div>{{scope.row.createDate| dateFilterD}}</div>
            </template>
          </el-table-column>
          <el-table-column label="所属部门">
            <template slot-scope="scope">
              <div>{{scope.row.orgName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="处理人：">
            <template slot-scope="scope">
              <div>{{scope.row.processUser || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="详情">
            <template slot-scope="scope">
              <el-button type="text" @click="checkSlider(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
    <!-- 查看 -->
    <check-slider ref="summarySheetCreditNoteRefundSliderRefs"></check-slider>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import { downLoadFileBlob } from '@/util/tool'
import summarySheetCreditNoteRefundSlider from '../slider/summarySheetCreditNoteRefundSlider'
import {
  generalRefundSummaryTable,
  reportGeneralRefundSummaryTable
} from '@/api/data/data'

export default {
  components: {
    pagination,
    'check-slider': summarySheetCreditNoteRefundSlider
  },
  mounted() {
    this.getList()
  },
  data() {
    return {
      invoiceType: [
        { label: '普通发票', value: '普通发票' },
        { label: '专用发票', value: '专用发票' }
      ], // 发票类型
      ticketType: [
        { label: '开票退票', value: '开票退票' },
        { label: '收票退票', value: '收票退票' }
      ], // 退票类型
      showAll: false, // 是否展开全部
      time: [],
      queryParams: {},
      tableHeight: window.innerHeight - 430,
      searchList: [],
      list: [],
      loadingTable: false, // 列表loading
      pageSize: 30, //
      currentPage: 1, // 页码
      total: 0, // 列表总数
      valList: [
        { value: '', column: 'subNumber' },
        { value: '', column: 'suName' },
        { value: '', column: 'invoiceRedNumber' },
        { value: '', column: 'invoiceType' },
        { value: '', column: 'type' },
        { value: '', column: 'createUser' },
        { value: '', column: 'createDate' },
        { value: '', column: 'processUser' }
      ]
    }
  },
  computed: {
    word: function() {
      if (this.showAll === false) {
        // 对文字进行处理
        return '展开'
      } else {
        return '收起'
      }
    }
  },
  methods: {
    getSummaries(param) {
      const sums = []
      param.columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
        } else if (index === 4) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.amount
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 5) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.taxAmount
          }, 0)
          sums[index] = total.toFixed(2)
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    closeSearch() {
      this.showAll = !this.showAll
    },
    getList() {
      this.loadingTable = true
      const params = {
        criteriaVoList: this.searchList ? this.searchList : [],
        queryPageName: ''
      }
      generalRefundSummaryTable(this.currentPage, this.pageSize, params).then(
        res => {
          if (res.data.code === 200) {
            this.list = res.data.obj.records
            this.total = res.data.obj.total
            this.loadingTable = false
          }
        }
      )
    },
    // 查询
    onSearch() {
      this.searchList = []
      if (this.time.length === 2) {
        this.searchList.push({
          value: this.time[0],
          endValue: this.time[1],
          column: 'processDate'
        })
      }
      if (this.valList.some(ele => ele.value) || this.time.length === 2) {
        this.pageSize = 30
        this.currentPage = 1
        this.valList.forEach(ele => {
          if (ele.value) {
            ele.collection = true
            this.searchList.push(ele)
          }
        })
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    // 重置
    onReset() {
      this.pageSize = 30
      this.currentPage = 1
      this.valList.forEach(ele => {
        delete ele.value
      })
      this.time = []
      this.searchList = []
      this.getList()
    },
    // 查看
    checkSlider(row) {
      this.$refs.summarySheetCreditNoteRefundSliderRefs.onInitialize(2, row)
    },
    // 导出
    exportOut() {
      const params = {
        criteriaVoList: this.searchList,
        queryPageName: ''
      }
      reportGeneralRefundSummaryTable(params)
        .then(res => {
          downLoadFileBlob(this, res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-table th > .cell {
  font-weight: 500;
  color: #4e555b;
}
</style>
